import React from 'react';

import image2007 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2007.jpg';
import image2008 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2008.jpg';
import image2012 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2012.jpg';
import image2013 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2013.jpg';
import image2014 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2014.jpg';
import image2015 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2015.jpg';
import image2016 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2016.jpg';
import image2017 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2017.jpg';
import image2018 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2018.jpg';
import image2019 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2019.jpg';
import image2021 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2021.jpg';
import image2022 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2022.jpg';
import image2023 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2023.jpg';
import image2024 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2024.jpg';
import image2025 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2025.jpg';
import image2026 from '../../../../Assets/Linkages/WorldSpaceWeek/AnnualGallery/WSW-2026.jpg';

const annualGallery = [
  { year: '2026', src: image2026, album: 'https://www.facebook.com/media/set/?set=a.1548489670632524&type=3' },
  { year: '2025', src: image2025, album: 'https://www.facebook.com/media/set/?set=a.1235310041950490&type=3' },
  { year: '2024', src: image2024, album: 'https://www.facebook.com/media/set/?set=a.952540250227472&type=3' },
  { year: '2023', src: image2023, album: 'https://www.facebook.com/media/set/?set=a.737919975022835&type=3' },
  { year: '2022', src: image2022, album: 'https://www.facebook.com/media/set/?set=a.5568324906607806&type=3' },
  { year: '2021', src: image2021, album: 'https://www.facebook.com/media/set/?set=a.5051742274932741&type=3' },
  { year: '2019', src: image2019, album: 'https://www.facebook.com/media/set/?set=a.2971016856338637&type=3' },
  { year: '2018', src: image2018, album: 'https://www.facebook.com/media/set/?set=a.2967669040006752&type=3' },
  { year: '2017', src: image2017, album: 'https://www.facebook.com/media/set/?set=a.2966972416743081&type=3' },
  { year: '2016', src: image2016, album: 'https://www.facebook.com/media/set/?set=a.2966830566757266&type=3' },
  { year: '2015', src: image2015, album: 'https://www.facebook.com/media/set/?set=a.873552962751714&type=3' },
  { year: '2014', src: image2014, album: 'https://www.facebook.com/media/set/?set=a.2966688246771498&type=3' },
  { year: '2013', src: image2013, album: 'https://www.facebook.com/media/set/?set=a.2966650710108585&type=3' },
  { year: '2012', src: image2012, album: 'https://www.facebook.com/media/set/?set=a.311822382258111&type=3' },
  { year: '2008', src: image2008, album: 'https://www.facebook.com/media/set/?set=a.2962941617146161&type=3' },
  { year: '2007', src: image2007, album: 'https://www.facebook.com/media/set/?set=a.2964353047005018&type=3' },
];

const WorldSpaceWeekLegacy = () => (
  <section className="world-space-week-legacy" aria-labelledby="world-space-week-legacy-title">
    <div className="world-space-week-legacy-inner">
      <header className="world-space-week-legacy-header">
        <p className="section-eyebrow">2007–2026 PHOTO ARCHIVE</p>
        <h2 id="world-space-week-legacy-title">World Space Week Through the Years</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />

        <p>
          Since 2005, the Institute of Space Technology (IST) has proudly led the celebration of
          World Space Week in Pakistan, serving as a vibrant hub for space-themed learning and
          exploration. Over the past 20 years, IST has engaged school, college, and university
          students through immersive STEM and STEAM-based activities, competitions, workshops,
          exhibitions, and hands-on projects, curating more than 200 unique and impactful modules.
          These efforts have ignited curiosity, nurtured innovation, and built a strong appreciation
          for the transformative power of space science and technology.
        </p>

        <p>
          This visual archive brings together milestone celebrations from the available annual
          albums. Select any year to revisit its participants, competitions, exhibitions, workshops,
          and memorable moments through the complete Facebook album.
        </p>
      </header>

      <div className="world-space-week-year-gallery">
        {annualGallery.map((item) => (
          <article className="world-space-week-year-card" key={item.year}>
            <a
              className="world-space-week-year-image"
              href={item.album}
              target="_blank"
              rel="noreferrer"
              aria-label={`Open the World Space Week ${item.year} Facebook album`}
            >
              <img src={item.src} alt={`World Space Week ${item.year}`} loading="lazy" />
              <span className="world-space-week-year-badge">{item.year}</span>
            </a>
            <div className="world-space-week-year-content">
              <h3>World Space Week {item.year}</h3>
              <a href={item.album} target="_blank" rel="noreferrer">
                View full album <span aria-hidden="true">&#8599;</span>
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default WorldSpaceWeekLegacy;
